export function getViewTransitionNameStylesForCourse(courseId) {
  return courseId ? {
    viewTransitionName: 'course-card-' + courseId,
    /* Use normal blending, so the new view sits on top and obscures the old view */
    mixBlendMode: 'normal',
    /* Prevent the default animation, so both views remain opacity:1 throughout the transition */
    animation: 'none',
    overflow: 'clip'
  } : undefined;
}